<template>
  <div>
    <div class="has-text-right" v-if="internalMessages.length > 2">
      <a @click="toggleAllOpen"
        ><span v-if="allOpen">{{
          $t('compTransitionReviewerMessages.fold')
        }}</span
        ><span v-else>{{
          $t('compTransitionReviewerMessages.unfold')
        }}</span></a
      >
    </div>
    <div
      class="columns"
      v-for="(message, index) in internalMessages"
      :key="index"
    >
      <div v-if="message.pos === 0" class="column is-1"></div>
      <div class="column">
        <section>
          <b-collapse
            class="card"
            animation="slide"
            aria-id="contentIdForA11y3"
            :open="allOpen || index >= internalMessages.length - 2"
          >
            <template #trigger="props">
              <div
                class="card-header"
                role="button"
                aria-controls="contentIdForA11y3"
                :aria-expanded="props.open"
              >
                <div
                  class="card-header-title"
                  style="font-size: 80%; min-height: 0"
                >
                  <span class="origin">{{ message.origin }}</span> &nbsp;
                  <span class="date">({{ $d(message.date, 'short') }})</span>
                  <a class="card-header-icon">
                    <b-icon :icon="props.open ? 'caret-down' : 'caret-up'">
                    </b-icon>
                  </a>
                </div>
              </div>
            </template>
            <div class="card-content">
              <div class="ql-editor" v-html="message.message"></div>
            </div>
          </b-collapse>
        </section>
        <!-- <div class="card">
          <div class="card-header">
            <span class="origin">{{ message.origin }}</span> &nbsp;
            <span class="date">({{ $d(message.date, 'short') }})</span>
          </div>
          <div class="card-content">
            <div class="ql-editor" v-html="message.message"></div>
          </div>
        </div> -->
      </div>
      <div v-if="message.pos !== 0" class="column is-1"></div>
    </div>

    <div class="has-text-right" v-if="internalMessages.length > 2">
      <a @click="toggleAllOpen"
        ><span v-if="allOpen">{{
          $t('compTransitionReviewerMessages.fold')
        }}</span
        ><span v-else>{{
          $t('compTransitionReviewerMessages.unfold')
        }}</span></a
      >
    </div>

    <form @submit.prevent="saveMessage">
      <b-field
        :label="$t('compTransitionReviewerMessages.label-message')"
        :type="{ 'is-danger': errors.has('content') }"
        :message="errors.first('content')"
      >
        <editor
          v-model="currentMessage"
          data-vv-name="content"
          v-validate="'required|min:1|max:10000'"
        />
      </b-field>
      <b-tooltip
        :label="disabledReason"
        type="is-dark"
        :active="disabled && !!disabledReason"
        multilined
      >
        <button type="submit" :disabled="disabled" class="button is-primary">
          <span class="icon is-small"><i class="fa fa-plus"></i></span>
          <span> {{ $t('add') }} </span>
        </button>
      </b-tooltip>
    </form>
  </div>
</template>

<script>
import { Background } from '@/mixins/background.js'

export default {
  name: 'Messages',
  props: {
    messages: {
      type: Array,
      required: true
    },
    // who's the owner (will be displayed on the left side)
    owner: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    disabledReason: {
      type: String,
      required: false,
      default: ''
    }
  },
  emit: ['onMessage'],
  mixins: [Background],
  components: {
    editor: () => import('@/components/Editor.vue')
  },
  $_veeValidate: {
    validator: 'new'
  },
  data: function () {
    return {
      currentMessage: '',
      allOpen: false
    }
  },
  computed: {
    internalMessages () {
      // decorate the message with their positions
      // based on owner info
      return this.messages.map((m) => {
        let pos = 0
        let r = {}
        Object.assign(r, m)
        if (this.owner.includes(m.origin)) {
          pos = 1
        }
        r.pos = pos
        return r
      })
    }
  },
  methods: {
    toggleAllOpen () {
      this.allOpen = !this.allOpen
      window.scrollTo(0, 0)
    },
    saveMessage () {
      this.validateBgUi(async () => {
        this.$emit('onMessage', this.currentMessage)
        this.currentMessage = ''
      })
    }
  }
}
</script>

<style scoped>
.origin {
  font-weight: bold;
  font-style: italic;
}
.date {
  color: gray;
}
.ql-editor {
  min-height: 0;
}
</style>
